/**
 * Javascript code that run on all screen of the application
 */

(function (yourcode) {
  yourcode(window.jQuery, window, document);
}(function ($, window, document) {
  $(function () {
    /**
     * Ajax setup csrf-token
     */
    $.ajaxSetup({
      headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        Accept: "application/json",
      },
    });

    /**
     * Search by tag, needs #input-search-tag as form and #btn-search-tag as button[type=submit]
     */
    $(document).off('click', '.search-tag').on('click', '.search-tag', function () {
      $("#input-search-tag").val($(this).html())
      $("#btn-search-tag").click()
    })

    /**
     * when element has data-toggle attribute assigned to "popover",
     * it will be handled by bootstrap, to display a bubble
     * https://getbootstrap.com/docs/4.6/components/popovers/
     */
    $(function () {
      $('[data-toggle="popover"]').popover({
        html: true
      })
    })

    /**
     * Default select 2 theme bootstrap
     */
    $.fn.select2.defaults.set("theme", "bootstrap");

    /**
     * Sidebar collapse (small screen)
     */
    const sidebarContainer = $('#sidebar-container');
    $('#sidebarContainerCollapse').on('click', function () {
      sidebarContainer.toggleClass('active');
    });
    $(window).on("resize", function () {
      if(sidebarContainer.hasClass('default-sidebar')) {
        if ($(window).width() > 900) {
          sidebarContainer.removeClass('active');
          $('#content-container').css('width', '80%');
        } else {
          $('#content-container').css('width', '100%');
        }
      }
    });

    /**
     * Sidebar group item collapse arrow animation
     */
    const divCollapse = $('.sidebar-items-collapse');
    divCollapse.on('show.bs.collapse', function () {
      $(this).prev('.menu-parent').addClass('active');
    });
    divCollapse.on('hide.bs.collapse', function () {
      $(this).prev('.menu-parent').removeClass('active');
    });

    /**
     * Change type of a-simple-switch rendered button
     */
    $('input[data-type="simple-switch"]').next('button._simple-switch-track').attr('type', 'button');

    /**
     * Sidebar scroll effect
     */
    const scrollContent = $('.menu-item-container .scroll-content')
    const updateShadows = (elem) => {
      if (!elem.length) return
      const scrollSlowness = 0.75;
      const maxScrollHeight = 50;
      const scrollPosTop = elem.scrollTop() / scrollSlowness > maxScrollHeight ? maxScrollHeight : elem.scrollTop() / scrollSlowness;

      // bottom is a bit tricky :(
      let scrollPosBottom = (elem[0].scrollHeight - elem[0].scrollTop - elem.height()) / scrollSlowness;
      scrollPosBottom = scrollPosBottom > maxScrollHeight ? maxScrollHeight : scrollPosBottom;

      elem.parent('.menu-item-container').children('.div-before-elem').css({
        height: scrollPosTop
      }).parent('.menu-item-container').children('.div-after-elem').css({
        height: scrollPosBottom
      });
    }

    scrollContent.scroll(function() {
      updateShadows($(this));
    });
    updateShadows(scrollContent)
  });
}))

/**
 * Global Constants
 */
window.constants = (function () {
  let modules = {};
  modules.METHOD_GET = "GET";
  modules.METHOD_POST = "POST";
  modules.METHOD_PUT = "PUT";
  modules.METHOD_DELETE = "DELETE";
  modules.METHOD_PATH = "PATH";
  modules.debug = false;
  modules.weekDays = [
    'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'
  ]
  modules.youtubeOembedUrl = "http://www.youtube.com/oembed?url=http://www.youtube.com/watch?v=";
  modules.youtubeEmbeddedVideoUrl = "https://www.youtube.com/embed/";
  modules.youtubeUrlReg = /(?:((http?(?:s)?:\/\/)?(www\.)?)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:embed\/|shorts\/|v\/|watch\?v=|watch\?(?:([^=]+)\=([^&]+))+&v=)))?((?:\w|-){11}|^(?:\w|-){11}$)((?:\&|\?)\S*)?/;
  modules.csrfAjax = {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  };
  modules.iframeSlideShowPrefix = "https://view.officeapps.live.com/op/embed.aspx?src=";
  modules.googleDriveUrlReg = /\/presentation\/d\/([a-zA-Z0-9-_]+)\//;
  modules.googleDriveEmbeded = function (id) {
    return 'https://docs.google.com/presentation/d/' + id +  '/embed?'
  }
  modules.phpConstant = $('#js-global-constants')
  modules.ckconfig = {
    fillEmptyBlocks: false,
    toolbar: {
      items: [
        'heading', '|', 'undo', 'redo', '|', 'bold', 'italic', 'underline', 'link', 'strikethrough', 'bulletedList', 'numberedList',
        '|', 'fontSize', 'alignment', 'insertImage', '|', 'blockQuote', 'insertTable', '|', 'htmlEmbed', 'codeBlock', 'code', '|',
        'indent', 'outdent', '|'
      ],
      shouldNotGroupWhenFull: false
    },
    // plugins: [
    //   CKFinder, CKFinderUploadAdapter, Alignment, Autoformat, AutoImage, AutoLink, Autosave, BlockQuote, Bold, Code, CodeBlock, Essentials,
    //   FindAndReplace, FontBackgroundColor, FontColor, FontFamily, FontSize, FullPage, GeneralHtmlSupport, Heading, Highlight, HorizontalLine,
    //   HtmlComment, HtmlEmbed, ImageBlock, ImageCaption, ImageInline, ImageInsert, ImageInsertViaUrl, ImageResize, ImageStyle,
    //   ImageTextAlternative, ImageToolbar, ImageUpload, Indent, IndentBlock, Italic, Link, LinkImage, List, ListProperties, Markdown,
    //   MediaEmbed, PageBreak, Paragraph, PasteFromMarkdownExperimental, PasteFromOffice, RemoveFormat, SimpleUploadAdapter,
    //   SourceEditing, SpecialCharacters, SpecialCharactersArrows, SpecialCharactersCurrency, SpecialCharactersEssentials, SpecialCharactersLatin,
    //   SpecialCharactersMathematical, SpecialCharactersText, Strikethrough, Subscript, Superscript, Table, TableCaption, TableCellProperties,
    //   TableColumnResize, TableProperties, TableToolbar, TextTransformation, TodoList, Underline, Undo
    // ],
    fontFamily: {
      supportAllValues: true
    },
    fontSize: {
      options: [10, 12, 14, 'default', 18, 20, 22],
      supportAllValues: true
    },
    heading: {
      options: [
        {
          model: 'paragraph',
          title: 'Paragraph',
          class: 'ck-heading_paragraph'
        },
        {
          model: 'heading1',
          view: 'h1',
          title: 'Heading 1',
          class: 'ck-heading_heading1'
        },
        {
          model: 'heading2',
          view: 'h2',
          title: 'Heading 2',
          class: 'ck-heading_heading2'
        },
        {
          model: 'heading3',
          view: 'h3',
          title: 'Heading 3',
          class: 'ck-heading_heading3'
        },
        {
          model: 'heading4',
          view: 'h4',
          title: 'Heading 4',
          class: 'ck-heading_heading4'
        },
        {
          model: 'heading5',
          view: 'h5',
          title: 'Heading 5',
          class: 'ck-heading_heading5'
        },
        {
          model: 'heading6',
          view: 'h6',
          title: 'Heading 6',
          class: 'ck-heading_heading6'
        }
      ]
    },
    htmlSupport: {
      allow: [
        {
          name: /^.*$/,
          styles: true,
          attributes: true,
          classes: true
        }
      ]
    },
    image: {
      resizeUnit: 'px',
      resizeOptions: [
        {
          name: 'resizeImage:original',
          label: 'Original',
          value: null
        },
        {
          name: 'resizeImage:custom',
          label: 'Custom',
          value: 'custom'
        },
        {
          name: 'resizeImage:100',
          label: '100px',
          value: '100'
        },
        {
          name: 'resizeImage:200',
          label: '200px',
          value: '200'
        },
        {
          name: 'resizeImage:300',
          label: '300px',
          value: '300'
        },
        {
          name: 'resizeImage:400',
          label: '400px',
          value: '400'
        },
        {
          name: 'resizeImage:500',
          label: '500px',
          value: '500'
        },
        {
          name: 'resizeImage:600',
          label: '600px',
          value: '600'
        },
        {
          name: 'resizeImage:700',
          label: '700px',
          value: '700'
        },
        {
          name: 'resizeImage:800',
          label: '800px',
          value: '800'
        },
        {
          name: 'resizeImage:900',
          label: '900px',
          value: '900'
        }
      ],
      toolbar: [
        'toggleImageCaption',
        'imageTextAlternative',
        '|',
        'imageStyle:inline',
        'imageStyle:wrapText',
        'imageStyle:breakText',
        '|',
        'resizeImage'
      ]
    },
    link: {
      addTargetToExternalLinks: true,
      defaultProtocol: 'https://',
      decorators: {
        toggleDownloadable: {
          mode: 'manual',
          label: 'Downloadable',
          attributes: {
            download: 'file'
          }
        }
      }
    },
    list: {
      properties: {
        styles: true,
        startIndex: true,
        reversed: true
      }
    },
    style: {
      definitions: [
        {
          name: 'Article category',
          element: 'h3',
          classes: ['category']
        },
        {
          name: 'Title',
          element: 'h2',
          classes: ['document-title']
        },
        {
          name: 'Subtitle',
          element: 'h3',
          classes: ['document-subtitle']
        },
        {
          name: 'Info box',
          element: 'p',
          classes: ['info-box']
        },
        {
          name: 'Side quote',
          element: 'blockquote',
          classes: ['side-quote']
        },
        {
          name: 'Marker',
          element: 'span',
          classes: ['marker']
        },
        {
          name: 'Spoiler',
          element: 'span',
          classes: ['spoiler']
        },
        {
          name: 'Code (dark)',
          element: 'pre',
          classes: ['fancy-code', 'fancy-code-dark']
        },
        {
          name: 'Code (bright)',
          element: 'pre',
          classes: ['fancy-code', 'fancy-code-bright']
        }
      ]
    },
    table: {
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties']
    },
    ckfinder: {
      uploadUrl: modules.phpConstant.data('ckeditor-image-url'),
    },
    htmlEmbed: {
      showPreviews: true
    },
    ui: {
      poweredBy: {
        label: ''
      }
    }
  };
  return modules;
}(window.jQuery, window, document))

/**
 * Global Actions
 */
window.actions = (function () {
  let modules = {};

  modules.showStatus = function(element, messages = '', label = 'danger') {
    if (messages === '') {
      return;
    }
    return $(`
            <div class="rounded pt-3 alert alert-${label}" role="alert">
                <button type="button" class="close close-x" data-dismiss="alert"">
                    <span  aria-hidden="true">&times;</span>
                </button>
                ${messages}
            </div>  
        `).appendTo(element);
  }

  modules.uploadFileAndGetUrl = async (fileData, routeUrl) => {
    let formData = new FormData();
    if(fileData) {
      formData.append('file', fileData);
    }
    try {
      return await actions.ajaxCall({
        url: routeUrl,
        data: formData,
        processData: false,
        contentType: false,
        method: 'POST',
      });
    } catch (error) {
      throw error;
    }
  }

  modules.uploadImageAndGetBase64Url = async (fileData, routeUrl) => {
    let formData = new FormData();
    if (fileData) {
      formData.append('file', fileData);
      formData.append('base64', 1);
    }
    try {
      return await actions.ajaxCall({
        url: routeUrl,
        data: formData,
        processData: false,
        contentType: false,
        method: 'POST',
      });
    } catch (error) {
      throw error;
    }
  }

  modules.extractGoogleSlidesId = function(url) {
    const pattern = constants.googleDriveUrlReg;
    const matches = url.match(pattern);
    if (matches && matches[1]) {
      return matches[1];
    }
    return null;
  }

  function getCleanData(editor) {
    let data = editor.baseGetData();
    if (data.trim() === '<p><br data-cke-filler="true"></p>' || data.trim() === '') {
      return '';
    }
    return data;
  }

  modules.ckinit = function (selector = '#ckeditor') {
    if ($(selector).length) {
      return ClassicEditor
        .create(document.querySelector(selector), constants.ckconfig)
        .then(function (editor) {
          editor.config.fillEmptyBlocks = false;
          editor.baseGetData = editor.getData;
          editor.getData = function() {
            return getCleanData(editor);
          };
          if (window.windowEditors === undefined) {
            window.windowEditors = {};
          }
          window.windowEditors[ selector ] = editor;
          const ckeditor = $(selector);
          const error = ckeditor.hasClass('is-invalid');
          if (error) {
            ckeditor.next().addClass('custom-error-box');
          }
          if (typeof QuestionModule !== 'undefined' && QuestionModule) {
            const autoGradeConfigInput = $('input[name="auto_config_grade"]');
            QuestionModule.resolvedCkeditor.resolve();
            editor.model.document.on( 'change:data', () => {
              if (QuestionModule !== undefined && autoGradeConfigInput.is(':checked')) {
                QuestionModule.autoFillGrade();
              }
            });
          }
        })
    }
    return false
  }

  modules.ajaxCall = function (options) {
    return $.ajax({
      headers: constants.csrfAjax,
      ...options
    })
  }

  modules.showLoading = function () {
    $('#loading-spinner').addClass('loading');
  }

  modules.hideLoading = function () {
    $('#loading-spinner').removeClass('loading');
  }

  return modules;
}(window.jQuery, window, document))
